import React, { useCallback, useState } from "react";
import { useHistory } from "react-router-dom";
import { getHomeDrawRequestsInfolist } from "../../api/BorrowerApi";
import { getMockHomeDrawRequestsInfolist } from "../../api/mock/MockBorrowerApi";
import { convertToDollar, formatDataProperties, handleErrorResponse } from "../../Helpers";
import { IHomeDrawRequestsObj, IHomeDrawRequestsView } from "../interfaces/Borrower";
import "../../styles/borrower/home.scss";
import { IErrorResponse, IProxyUser } from "../interfaces/Global";
import BWHomeViewAllFrame from "./BWHomeViewAllFrame";
import { Card } from "semantic-ui-react";
import BWDrawRequestCard from "./home/BWDrawRequestCard";
import BCEmptyState from "../ui/BCEmptyState";
import BCConfirmationModal from "../ui/BCConfirmationModal";
import { FeatureFlags } from "../constants/LocalServerConstants";

interface IBWHomeDrawRequests {
  isGreaterThanTablet: boolean;
  isSidebar: boolean;
  isMessage: boolean;
  setIsMessage: (value: boolean) => React.Dispatch<React.SetStateAction<boolean>>;
  errorResponse: IErrorResponse | undefined; 
  setErrorResponse: (value: boolean) => React.Dispatch<React.SetStateAction<IErrorResponse | undefined>> 
  proxyUser: IProxyUser | undefined;
}

const BWHomeDrawRequests = ({...props} : IBWHomeDrawRequests) => {
  const [isLoading, setIsLoading] = useState(true as boolean);
  const [homeDrawRequestsInfoData, setHomeDrawRequestsInfoData] = useState([] as IHomeDrawRequestsObj[]);
  const [isDeleteDrawModalOpen, setIsDeleteDrawModalOpen] = useState(false as boolean);
  const [selectedLoanDrawId, setSelectedLoanDrawId] = useState("" as string);

  const history = useHistory();
  const handleError = useCallback(() => {
    history.push("/error");
  }, [history]);

  const convertToTableFormat = (requests) => {
    const drawRequestsTable = [] as IHomeDrawRequestsView[];
    requests.forEach(request => drawRequestsTable.push({
      "createdOn": request.createdOn,
      "name": request.name,
      "loan": request.loan,
      "loanDrawApplicationStatus": request.loanDrawApplicationStatus,
      "loanProperty": request.loanProperty,
      "requestedAmount": convertToDollar(request.drawRequestAmount),
      "approvedAmount": convertToDollar(request.approvedAmount),
      "inspectionScheduled": request.inspectionStatus === "Inspection Completed" ? "Completed" : "Incompleted",
    }));

    return formatDataProperties(drawRequestsTable, [{field: "loanDrawApplicationStatus", action: "rename", name: "Application Status"}, {field: "inspectionScheduled", action: "rename", name: "Inspection Status"}]);
  };

  const getHomeDrawRequestsInfoAysnc = async () => {
    try {
      const response = FeatureFlags.IS_MOCK ? await getMockHomeDrawRequestsInfolist() : await getHomeDrawRequestsInfolist(props.proxyUser && props.proxyUser.id);
      if (response && response.ok) {
        props.setIsMessage(false);
        const homeDrawRequestsInfolist = await response.json();
        const homeDrawRequestsViews = [] as IHomeDrawRequestsObj[];
        homeDrawRequestsInfolist.forEach((homeDrawRequestsInfolistItem) => {
          homeDrawRequestsViews.push(homeDrawRequestsInfolistItem as IHomeDrawRequestsObj);
        });
        
        setHomeDrawRequestsInfoData(homeDrawRequestsViews.sort((a, b) => new Date(b.createdOn).getTime() - new Date(a.createdOn).getTime()));
      }
      else {
        await handleErrorResponse(response, props.setIsMessage, props.setErrorResponse);
      }
    }
    catch (error) {
      handleError();
    }

    setIsLoading(false);
  };

  const deleteLoanDrawRequestAsync = async () => {
    console.log(selectedLoanDrawId);
  };

  const DrawRequestCardView = ({requests}) => {
    return (
      <React.Fragment>
        <BCConfirmationModal 
          isModalOpen={isDeleteDrawModalOpen}
          setIsModalOpen={setIsDeleteDrawModalOpen}
          modalHeader="Delete loan draw request?"
          modalContent="Loan Draw request will be deleted"
          handleConfirm={deleteLoanDrawRequestAsync}
        />
        {requests && requests.length > 0 ? <Card.Group itemsPerRow={props.isGreaterThanTablet ? 3 : 1}>
          {requests.map((drawReqest, i) => <BWDrawRequestCard drawRequest={drawReqest} index={i} setIsDeleteDrawModalOpen={setIsDeleteDrawModalOpen} setSelectedLoanDrawId={setSelectedLoanDrawId}/>)}
        </Card.Group>
        : <BCEmptyState
            emptyStateClass="home-content-empty-state"
            icon="clipboard outline"
            text="You currently have no loan draw applications"
            content="Starting a loan draw application will create a new loan draw application tile in this section. Any unfinished loan draw applications can be resumed here"
          />
        }
      </React.Fragment>
    );
  };

    return (
      <React.Fragment>
        <BWHomeViewAllFrame 
          isGreaterThanTablet={props.isGreaterThanTablet}
          isSidebar={props.isSidebar}
          isMessage={props.isMessage}
          setIsMessage={props.setIsMessage}
          errorResponse={props.errorResponse}
          setErrorResponse={props.setErrorResponse}
          proxyUser={props.proxyUser}
          isLoading={isLoading}
          breadcrumbsCurrent="Draw Requests"
          formattedDate={convertToTableFormat(homeDrawRequestsInfoData)}
          getApiInfoAsync={getHomeDrawRequestsInfoAysnc}
          infolistStyleSwitch={true}
          cardViewComponents={<DrawRequestCardView requests={homeDrawRequestsInfoData}/>}
          emptyState={{icon: "clipboard outline", text: "You currently have no loan draw applications"}}
          tableDataRules={[{ field: "Created On", rule: "hide" }]}
          tableSortable={["Name", "Loan", "Application Status", "Loan Property", "Inspection Status"]}
          ellipsis
          handleDrawRequest
        />
      </React.Fragment>
    );
  };
  
export default BWHomeDrawRequests;